import type { FC, ReactElement } from "react";
import React from "react";
import { useLocation } from "react-router-dom";
import LoadingComponent from "@arenko-group/arenko-ui/dist/components/LoadingComponent";
import { useAuth0 } from "@auth0/auth0-react";
import classNames from "classnames";
import AppHeader from "@/components/AppHeader";
import NavMenu from "@/components/NavMenu";
import { identifyAndTrackUser } from "@/helpers/user.helpers";
import useMenuToggleState from "@/hooks/useMenuToggleState";
import type { NavRouteTree } from "@/routerConfig";
import { findParentForPath } from "@/routerConfig/router.helpers";

type AppLayoutProps = {
  menuItems: NavRouteTree;
  children: ReactElement;
};

/**
 *
 * @returns Header and NavMenu
 */
const AppLayout: FC<AppLayoutProps> = ({ menuItems, children }) => {
  const [menuExpanded, setMenuExpanded] = useMenuToggleState();
  const { pathname } = useLocation();
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  identifyAndTrackUser();

  if (!isLoading && !isAuthenticated) {
    loginWithRedirect();
  }

  if (!isAuthenticated) {
    return <LoadingComponent height={200} />;
  }

  const parent = findParentForPath(menuItems, pathname);
  return (
    <div className={classNames("root-layout", { expanded: menuExpanded })}>
      <AppHeader
        menuToggle={() => {
          setMenuExpanded(!menuExpanded);
        }}
        menuExpanded={menuExpanded}
      />

      <nav id="app-nav">
        <NavMenu menuItems={menuItems} activeSectionLabel={parent?.label} />
      </nav>

      {children}
    </div>
  );
};

export default AppLayout;
